document.addEventListener('DOMContentLoaded', function () {
    var config = JSON.parse(document.getElementById("wizard-configuration").textContent);
    if (config && config.locale !== "en" && config.translations) {
        window.snr_translations = config.translations;
    }
    config.moneyFormat = function (cents) {
        var format = config.moneyFormatMask;
        if (typeof cents === "string") {
            cents = cents.replace('.', '');
        }
        var value = (cents / 100).toFixed(2);
        var formatString = format || window.moneyFormat || "${{amount}}";
        if (formatString.indexOf("{{amount_no_decimals}}") !== -1) {
            value = (cents / 100).toFixed(0);
            return formatString.replace("{{amount_no_decimals}}", value);
        }
        if (formatString.indexOf("{{amount_no_decimals_with_comma_separator}}") !== -1) {
            value = (cents / 100).toFixed(0);
            value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return formatString.replace("{{amount_no_decimals_with_comma_separator}}", value);
        }
        if (formatString.indexOf("{{amount_with_comma_separator}}") !== -1) {
            value = (cents / 100).toFixed(2);
            value = value.replace('.', ',');
            return formatString.replace("{{amount_with_comma_separator}}", value);
        }
        return formatString.replace("{{amount}}", value);
    };

    var propertyLabels = config.propertyLabels || {};

    config.addToCart = function (item, onError) {
        var addToCartFn = window.snrAddToCart;
        if (typeof addToCartFn !== "function") {
            if (typeof onError === "function") {
                onError("Sorry, we could not add this item to your cart. Please try again.");
            }
            return;
        }
        // console.log(item);
        // console.log(config);

        var properties = {};
        var extras = [];

        var displayStarName = item.starName;
        if (item.starNameTwo) {
            displayStarName = item.starName + " & " + item.starNameTwo;
            properties["_star_name_two"] = item.starNameTwo;
        }

        properties[propertyLabels.starName || "Star Name"] = displayStarName;
        properties["_star_name"] = item.starName;

        if (item.personalizedMessage) {
            properties[propertyLabels.personalizedMessage || "Personalized Message"] = item.personalizedMessage;
            properties["_message"] = item.personalizedMessage;
        }
        if (item.date) {
            properties[propertyLabels.date || "Date"] = item.dateFormatted;
            properties["_date"] = item.date;
        }

        if (item.extraProducts && item.extraProducts.length) {
            for (var i = 0; i < item.extraProducts.length; i++) {
                var p = item.extraProducts[i];
                extras.push(p);
            }
        }

        if (item.extraProductsExtended && item.extraProductsExtended.length) {
            for (var j = 0; j < item.extraProductsExtended.length; j++) {
                var ep = item.extraProductsExtended[j];
                extras.push(ep);
            }
        }

        if (item.starMap && config.map) {
            extras.push({ id: config.map.id, quantity: 1 });
        }

        if (item.constellationPreference == "custom") {
            var constellationProps = {
                "_constellation_id": item.constellation,
                "_constellation_name": item.constellationName
            };
            constellationProps[propertyLabels.constellation || "Constellation"] = item.constellationName;
            extras.push({ id: config.constellations.id, quantity: 1, properties: constellationProps });
        }

        // select correct variant according brightness selection
        var type = "standard";
        if (item.extraBinary) {
            type = "binary";
        } else if (item.extraBrightness) {
            type = "extra";
        }

        // pass current certificate language
        properties["_language"] = config.certificateLocale || "gb_GB";

        properties["_type"] = type;
        var variantId = config.brightness && config.brightness[type] ? config.brightness[type].id : config.product.variants[0].id;

        addToCartFn({ mainVariantId: variantId, properties: properties, extras: extras }).then(function () {
            window.location = config.redirectUrl;
        }).catch(function (error) {
            var msg = (error && error.message) || "Sorry, we could not add this item to your cart. Please try again.";
            if (typeof onError === "function") { onError(msg); }
        });
    };

    config.setDistractionFree = function (active) {
        document.body.classList.toggle("distraction-free", active);
    };

    // Settings
    config.countryCode = config.certificateLocale || "gb_GB"; // language of the cert

    // Misc
    /*
    config.shipping = config.shipping;
    config.guarantee = config.guarantee;
     */

    // certificate
    config.cert = {};
    config.cert.imagePreview = config.preview.cert;

    // Product
    // config.product.title
    // config.product.description (html)
    // config.product.image
    // config.product.images
    // config.product.price
    // config.product.priceBase
    config.product.priceBase = config.product.compare_at_price_max ? config.product.compare_at_price_max : config.product.compare_at_price;

    config.product.productDetails = config.productMeta.product_details ? config.productMeta.product_details : "";
    if (config.locale === "fr" && config.product.productDetails) {
        var specRoot = document.createElement("div");
        specRoot.innerHTML = config.product.productDetails;
        var specRows = [];
        specRoot.querySelectorAll("strong").forEach(function (label) {
            var value = "", next = label.nextSibling;
            while (next && !(next.nodeType === 1 && next.tagName === "STRONG")) {
                value += next.textContent || "";
                next = next.nextSibling;
            }
            var title = label.textContent.replace(/\s*:\s*$/, "").trim();
            if (title && value.trim()) specRows.push([title, value.trim()]);
        });
        if (specRows.length) {
            var specs = document.createElement("dl"); specs.className = "fr-info-rows fr-product-specs";
            specRows.forEach(function (row) { var item=document.createElement("div"),label=document.createElement("dt"),value=document.createElement("dd");label.textContent=row[0];value.textContent=row[1];item.appendChild(label);item.appendChild(value);specs.appendChild(item); });
            config.product.productDetails = specs.outerHTML;
        }
    }

    config.product.features = config.productMeta.features ? config.productMeta.features : "";
    if (config.locale === "fr") config.product.features = config.product.features.replace("Nommez une véritable étoile", "Nom d’étoile personnalisé").replace("Inscrite sur le Registre", "Inscription au registre privé").replace("Atlas stellaire GRATUIT", "Atlas stellaire inclus").replace("Application de recherche d'étoiles", "Application pour retrouver votre étoile");

    config.product.ctaNote = config.locale === "fr" ? "<p>" + config.digitalCopy + "</p>" : (config.productMeta.cta_note ? config.productMeta.cta_note : "");

    if (String(config.product.id) === "15502337507697") {
        config.product.ctaNote = "<p>" + config.includedSetCopy + "</p>" + config.product.ctaNote;
        (config.extraProducts || []).forEach(function (extra) {
            if (String(extra.id) === "15500423037297") {
                extra.title = config.additionalSetCopy;
            }
        });
    }

    if (config.locale === "fr") {
        [config.extraProducts, config.extraProductsExtended].forEach(function (list) {
            (list || []).forEach(function (extra) {
                if (extra.handle === "extra-wooden-frame-deed") extra.title = config.frameCertificateCopy;
            });
        });
    }

    // Constellation
    if (config.productConstellation) {
        config.constellations = {};
        config.constellations.id = config.productConstellation.id; // variant already selected
        config.constellations.price = config.productConstellation.price;
        config.constellations.priceBase = config.productConstellation.compare_at_price;
        config.constellations.list = [{"id":"2","constellation":"Andromeda","abbr":"and","constellation_type":"popular","description":"For the princess"},{"id":"3","constellation":"Antlia","abbr":"ant","constellation_type":null,"description":null},{"id":"4","constellation":"Apus","abbr":"aps","constellation_type":null,"description":null},{"id":"5","constellation":"Aquarius","abbr":"aqr","constellation_type":"zodiac","description":"20 Jan - 18 Feb"},{"id":"6","constellation":"Aquila","abbr":"aql","constellation_type":null,"description":null},{"id":"7","constellation":"Ara","abbr":"ara","constellation_type":null,"description":null},{"id":"8","constellation":"Aries","abbr":"ari","constellation_type":"zodiac","description":"21 Mar - 19 Apr"},{"id":"9","constellation":"Auriga","abbr":"aur","constellation_type":null,"description":null},{"id":"10","constellation":"Bootes","abbr":"boo","constellation_type":null,"description":null},{"id":"11","constellation":"Caelum","abbr":"cae","constellation_type":null,"description":null},{"id":"12","constellation":"Camelopardalis","abbr":"cam","constellation_type":null,"description":null},{"id":"13","constellation":"Cancer","abbr":"cnc","constellation_type":"zodiac","description":"21 Jun - 22 Jul"},{"id":"14","constellation":"Canes","abbr":"cvn","constellation_type":null,"description":null},{"id":"15","constellation":"Canis Major","abbr":"cma","constellation_type":null,"description":null},{"id":"16","constellation":"Canis Minor","abbr":"cmi","constellation_type":null,"description":null},{"id":"17","constellation":"Capricorn","abbr":"cap","constellation_type":"zodiac","description":"22 Dec - 19 Jan"},{"id":"18","constellation":"Carina","abbr":"car","constellation_type":null,"description":null},{"id":"19","constellation":"Cassiopeia","abbr":"cas","constellation_type":null,"description":null},{"id":"20","constellation":"Centaurus","abbr":"cen","constellation_type":null,"description":null},{"id":"21","constellation":"Cepheus","abbr":"cep","constellation_type":null,"description":null},{"id":"22","constellation":"Cetus","abbr":"cet","constellation_type":null,"description":null},{"id":"23","constellation":"Chamaeleon","abbr":"cha","constellation_type":null,"description":null},{"id":"24","constellation":"Circinus","abbr":"cir","constellation_type":null,"description":null},{"id":"25","constellation":"Columba","abbr":"col","constellation_type":null,"description":null},{"id":"26","constellation":"Coma Berenices","abbr":"com","constellation_type":null,"description":null},{"id":"27","constellation":"Corona Australis","abbr":"cra","constellation_type":null,"description":null},{"id":"28","constellation":"Corona Borealis","abbr":"crb","constellation_type":"popular","description":"For the true romantic"},{"id":"29","constellation":"Corvus","abbr":"crv","constellation_type":null,"description":null},{"id":"30","constellation":"Crater","abbr":"crt","constellation_type":null,"description":null},{"id":"31","constellation":"Crux","abbr":"cru","constellation_type":null,"description":null},{"id":"32","constellation":"Cygnus","abbr":"cyg","constellation_type":null,"description":null},{"id":"33","constellation":"Delphinus","abbr":"del","constellation_type":null,"description":null},{"id":"34","constellation":"Dorado","abbr":"dor","constellation_type":null,"description":null},{"id":"35","constellation":"Draco","abbr":"dra","constellation_type":null,"description":null},{"id":"36","constellation":"Equuleus","abbr":"equ","constellation_type":null,"description":null},{"id":"37","constellation":"Eridanus","abbr":"eri","constellation_type":null,"description":null},{"id":"38","constellation":"Fornax","abbr":"for","constellation_type":null,"description":null},{"id":"39","constellation":"Gemini","abbr":"gem","constellation_type":"zodiac","description":"21 May - 20 Jun"},{"id":"40","constellation":"Grus","abbr":"gru","constellation_type":null,"description":null},{"id":"41","constellation":"Hercules","abbr":"her","constellation_type":"popular","description":"For the man in your life"},{"id":"42","constellation":"Horologium","abbr":"hor","constellation_type":null,"description":null},{"id":"43","constellation":"Hydra","abbr":"hya","constellation_type":null,"description":null},{"id":"44","constellation":"Hydrus","abbr":"hyi","constellation_type":null,"description":null},{"id":"45","constellation":"Indus","abbr":"ind","constellation_type":null,"description":null},{"id":"46","constellation":"Lacerta","abbr":"lac","constellation_type":null,"description":null},{"id":"47","constellation":"Leo","abbr":"leo","constellation_type":"zodiac","description":"23 Jul - 22 Aug"},{"id":"48","constellation":"Leo Minor","abbr":"lmi","constellation_type":null,"description":null},{"id":"49","constellation":"Lepus","abbr":"lep","constellation_type":null,"description":null},{"id":"50","constellation":"Libra","abbr":"lib","constellation_type":"zodiac","description":"23 Sep - 22 Oct"},{"id":"51","constellation":"Lupus","abbr":"lup","constellation_type":null,"description":null},{"id":"52","constellation":"Lynx","abbr":"lyn","constellation_type":null,"description":null},{"id":"53","constellation":"Lyra","abbr":"lyr","constellation_type":"popular","description":"For the music lover"},{"id":"54","constellation":"Mensa","abbr":"men","constellation_type":null,"description":null},{"id":"55","constellation":"Microscopium","abbr":"mic","constellation_type":null,"description":null},{"id":"56","constellation":"Monoceros","abbr":"mon","constellation_type":"popular","description":"For the young at heart"},{"id":"57","constellation":"Musca","abbr":"mus","constellation_type":null,"description":null},{"id":"58","constellation":"Norma","abbr":"nor","constellation_type":null,"description":null},{"id":"59","constellation":"Octans","abbr":"oct","constellation_type":null,"description":null},{"id":"60","constellation":"Ophiuchus","abbr":"oph","constellation_type":null,"description":null},{"id":"61","constellation":"Orion","abbr":"ori","constellation_type":"popular","description":"For the loving father"},{"id":"62","constellation":"Pavo","abbr":"pav","constellation_type":null,"description":null},{"id":"63","constellation":"Pegasus","abbr":"peg","constellation_type":null,"description":null},{"id":"64","constellation":"Perseus","abbr":"per","constellation_type":null,"description":null},{"id":"65","constellation":"Phoenix","abbr":"phe","constellation_type":"popular","description":"For the unforgotten"},{"id":"66","constellation":"Pictor","abbr":"pic","constellation_type":"popular","description":"For the art lover"},{"id":"67","constellation":"Pisces","abbr":"psc","constellation_type":"zodiac","description":"19 Feb - 20 Mar"},{"id":"68","constellation":"Piscis Austrinus","abbr":"psa","constellation_type":null,"description":null},{"id":"69","constellation":"Puppis","abbr":"pup","constellation_type":null,"description":null},{"id":"70","constellation":"Pyxis","abbr":"pyx","constellation_type":"popular","description":"For the traveller"},{"id":"71","constellation":"Reticulum","abbr":"ret","constellation_type":null,"description":null},{"id":"72","constellation":"Sagitta","abbr":"sge","constellation_type":null,"description":null},{"id":"73","constellation":"Sagittarius","abbr":"sgr","constellation_type":"zodiac","description":"22 Nov - 21 Dec"},{"id":"74","constellation":"Scorpius","abbr":"sco","constellation_type":"zodiac","description":"23 Oct - 21 Nov"},{"id":"75","constellation":"Sculptor","abbr":"scl","constellation_type":null,"description":null},{"id":"76","constellation":"Scutum","abbr":"sct","constellation_type":null,"description":null},{"id":"77","constellation":"Serpens","abbr":"ser","constellation_type":null,"description":null},{"id":"78","constellation":"Sextans","abbr":"sex","constellation_type":null,"description":null},{"id":"79","constellation":"Taurus","abbr":"tau","constellation_type":"zodiac","description":"20 Apr - 20 May"},{"id":"80","constellation":"Telescopium","abbr":"tel","constellation_type":"popular","description":"For the science lover"},{"id":"81","constellation":"Triangulum","abbr":"tri","constellation_type":null,"description":null},{"id":"82","constellation":"Triangulum Australe","abbr":"tra","constellation_type":null,"description":null},{"id":"83","constellation":"Tucana","abbr":"tuc","constellation_type":null,"description":null},{"id":"84","constellation":"Ursa Major","abbr":"uma","constellation_type":"popular","description":"For the loving mother"},{"id":"85","constellation":"Ursa Minor","abbr":"umi","constellation_type":"popular","description":"For the beloved child"},{"id":"86","constellation":"Vela","abbr":"vel","constellation_type":null,"description":null},{"id":"87","constellation":"Virgo","abbr":"vir","constellation_type":"zodiac","description":"23 Aug - 22 Sep"},{"id":"88","constellation":"Volans","abbr":"vol","constellation_type":null,"description":null},{"id":"89","constellation":"Vulpecula","abbr":"vul","constellation_type":null,"description":null}];
    }

    // Star Map
    if (config.productMap) {
        config.map = {};

        config.map.id = config.productMap.id; // variant already selected
        config.map.price = config.productMap.price;
        config.map.priceBase = config.productMap.compare_at_price;
        config.map.imagePreview = config.preview.starmap;
    }

    // Brightness
    config.brightness = {};
    if (config.product && Array.isArray(config.product.variants)) {
        var variants = config.product.variants;
        var types = ["standard", "extra", "binary"];
        for (var t = 0; t < types.length; t += 1) {
            var typeName = types[t];
            var variant = null;
            for (var v = 0; v < variants.length; v += 1) {
                var candidate = variants[v];
                if (typeof candidate.sku === "string" && candidate.sku.toLowerCase().indexOf(typeName) !== -1) {
                    variant = candidate;
                    break;
                }
            }
            if (variant) {
                config.brightness[typeName] = {
                    id: variant.id,
                    title: config.locale === "fr" ? ({standard: "Standard", extra: "Étoile très brillante", binary: "Étoile double"}[typeName]) : (variant.title || typeName),
                    price: variant.price - config.product.price,
                    basePrice: variant.compare_at_price - config.product.price,
                    image: config.brightnessImages && config.brightnessImages[typeName] ? config.brightnessImages[typeName] : ""
                };
            }
        }
    }

    // Extras
    for (var j in config.extraProducts) {
        if (config.extraProducts[j].variants.length > 0) { config.extraProducts[j].id = config.extraProducts[j].variants[0].id; }
        config.extraProducts[j].priceBase = config.extraProducts[j].compare_at_price;
    }

    for (var k in config.extraProductsExtended) {
        if (config.extraProductsExtended[k].variants.length > 0) { config.extraProductsExtended[k].id = config.extraProductsExtended[k].variants[0].id; }
        config.extraProductsExtended[k].priceBase = config.extraProductsExtended[k].compare_at_price;
    }

    if (config.locale === "fr") {
        var wizardRoot = document.getElementById("wizard");
        var imageDescriptions = config.imageDescriptions || [];
        var fileName = function (url) {
            return new URL(url, window.location.href).pathname.split("/").pop();
        };
        var setAttributeIfChanged = function (node, name, value) {
            if (value && node.getAttribute(name) !== value) node.setAttribute(name, value);
        };
        var refreshAccessibility = function () {
            wizardRoot.querySelectorAll("img").forEach(function (image) {
                var index = imageDescriptions.findIndex(function (entry) {
                    return fileName(entry.url) === fileName(image.src);
                });
                if (index < 0) return;
                var entry = imageDescriptions[index];
                var description = entry.alt || config.product.title + ", " + config.imageViewLabel + " " + (index + 1);
                setAttributeIfChanged(image, "alt", description);
                if (image.getAttribute("role") === "button") {
                    setAttributeIfChanged(image, "aria-label", config.imageShowLabel + " " + (index + 1) + " : " + description);
                }
            });
            var nameLabels = config.translations && config.translations.step_star_name;
            if (nameLabels) {
                wizardRoot.querySelectorAll('input[type="text"][maxlength="60"]').forEach(function (input) {
                    if (input.placeholder === nameLabels.placeholder) setAttributeIfChanged(input, "aria-label", propertyLabels.starName);
                    if (input.placeholder === nameLabels.second_placeholder) setAttributeIfChanged(input, "aria-label", nameLabels.second_name_field);
                });
            }
            wizardRoot.querySelectorAll(".date-picker-jump-to select").forEach(function (select) {
                var options = Array.from(select.options);
                if (options.length === 12 && options.every(function (option, index) { return Number(option.value) === index; })) {
                    setAttributeIfChanged(select, "aria-label", config.monthLabel);
                    options.forEach(function (option) {
                        var name = config.monthNames[Number(option.value)];
                        if (name && option.textContent !== name) option.textContent = name;
                    });
                } else if (options.length && options.every(function (option) { return /^\d{4}$/.test(option.value); })) {
                    setAttributeIfChanged(select, "aria-label", config.yearLabel);
                }
            });
            wizardRoot.querySelectorAll('textarea[maxlength="150"]').forEach(function (input) {
                setAttributeIfChanged(input, "aria-label", propertyLabels.personalizedMessage);
            });
        };
        var accessibilityFrame = null;
        var accessibilityObserver = new MutationObserver(function () {
            if (accessibilityFrame !== null) return;
            accessibilityFrame = requestAnimationFrame(function () {
                accessibilityFrame = null;
                refreshAccessibility();
            });
        });
        accessibilityObserver.observe(wizardRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "alt", "aria-label"] });
    }

    if ((String(window.Shopify && window.Shopify.theme && window.Shopify.theme.id) === "209654940017" || (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main"))) {
        try {
            var incoming = new URL(window.location.href);
            var carry = JSON.parse(sessionStorage.getItem("snr-additional-name") || "null");
            if (incoming.searchParams.get("snr_additional") === "1" && carry &&
                carry.path === incoming.pathname && Date.now() - carry.time < 1800000 &&
                typeof carry.name === "string" && carry.name.trim().length > 0 && carry.name.length <= 60) {
                config.initialStarName = carry.name;
                sessionStorage.removeItem("snr-additional-name");
                incoming.searchParams.delete("snr_additional");
                history.replaceState(history.state, "", incoming.pathname + incoming.search + incoming.hash);
            }
        } catch (error) {}
    }

    config.giftTotal = function (fields) { return window.snrGiftTotal(config, fields); };


    var packages = (config.packageNavigation || []).map(function(item,index){ item.order=index; return item; }).sort(function(a,b){return a.price-b.price || a.order-b.order;});
    packages.forEach(function(item){var url=new URL(item.url,window.location.origin);if(window.Shopify&&Shopify.theme&&Shopify.theme.role!=="main")url.searchParams.set("preview_theme_id",Shopify.theme.id);item.url=url.pathname+url.search;});
    var packageIndex=packages.findIndex(function(item){return String(item.id)===String(config.product.id);});
    if(packageIndex>=0&&packages.length>1){config.packagePrevious=packages[(packageIndex+packages.length-1)%packages.length];config.packageNext=packages[(packageIndex+1)%packages.length];}
    config.rememberPackageDetails=function(fields,target){
        if((fields.starName||"").length>target.nameLimit){window.alert("Ce coffret accepte un nom de "+target.nameLimit+" caractères maximum. Raccourcissez le nom avant de changer de coffret pour conserver votre saisie.");return false;}
        var personal={};["starName","starNameTwo","date","dateFormatted","personalizedMessage"].forEach(function(key){if(typeof fields[key]==="string")personal[key]=fields[key];});
        try{sessionStorage.setItem("snr-fr-package-personal",JSON.stringify({path:new URL(target.url,location.origin).pathname,time:Date.now(),fields:personal}));}catch(error){}
        return true;
    };
    try{
        var saved=JSON.parse(sessionStorage.getItem("snr-fr-package-personal")||"null");
        if(saved&&saved.path===location.pathname&&Date.now()-saved.time<1800000&&saved.fields){
            var personal={},limits={starName:60,starNameTwo:30,date:40,dateFormatted:100,personalizedMessage:150};
            Object.keys(limits).forEach(function(key){var value=saved.fields[key];if(typeof value==="string"&&value.length<=limits[key])personal[key]=value;});
            config.initialPersonalFields=personal;sessionStorage.removeItem("snr-fr-package-personal");
        }
    }catch(error){}
    var el = document.createElement("snr-product-app");
    el.config = config;
    document.getElementById("wizard").appendChild(el);
});



(function(){
  function setup(){
    var root=document.getElementById('wizard');if(!root)return;
    var loaded=new WeakSet();
    function refresh(){if(!window.Trustpilot||typeof window.Trustpilot.loadFromElement!=='function')return;root.querySelectorAll('.fr-builder-trust').forEach(function(widget){if(!loaded.has(widget)){loaded.add(widget);window.Trustpilot.loadFromElement(widget,true);}});}
    new MutationObserver(refresh).observe(root,{childList:true,subtree:true});
    window.addEventListener('load',refresh);refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
